import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Switch, Route } from 'react-router-dom';

import Loading from 'components/Loading';
import {
  LoanPairs,
  LoanPairSetup,
  CompanyAccount,
} from '../views/Accounting';

import { HomeNavbar } from '../components/Nevbars';
import { MainFooter } from '../components/Footers';
import { MainSidebar } from '../components/Sidebar';
import { NotFound, AccessDenied } from '../components/Error';
import { hasModuleAccess } from '../utils/functions/accessRight';
import * as actions from '../redux/actions';

export function Accounting() {
  const module = 'ACCOUNTING';
  const prefix = '/accounting';
  const name = 'accounting';
  const dispatch = useDispatch();

  const me = useSelector((state) => state.me);

  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const handleOnMobileNavOpen = () => setMobileNavOpen(true);
  const handleOnMobileNavClose = () => setMobileNavOpen(false);

  useEffect(() => {
    dispatch(actions.meGet());
    return () => {};
  }, []);

  if (!me.userData) {
    return <Loading />;
  }
  if (!hasModuleAccess(me, module)) {
    return <AccessDenied moduleLabel="จัดการบัญชีบริษัท" />;
  }

  return (
    <div className="min-h-screen">
      <MainSidebar
        onMobileClose={handleOnMobileNavClose}
        openMobile={isMobileNavOpen}
        me={me}
      />
      <HomeNavbar onMobileNavOpen={handleOnMobileNavOpen} />

      <div
        className={`relative min-h-screen pt-2 px-8 transition-all duration-200 ${
          'lg:ml-20'
        }`}
      >
        <div className="py-4">
          <Switch>
            <Route exact path={`${prefix}/loan-pairs`}>
              <LoanPairs title="ยืม-คืน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/loan-pairs-setup`}>
              <LoanPairSetup title="ตั้งค่าคู่ยืม-คืน" subtitle={name} />
            </Route>
            <Route exact path={`${prefix}/company-account`}>
              <CompanyAccount title="บัญชีบริษัท" subtitle={name} />
            </Route>
            <Route path="*">
              <NotFound />
            </Route>
          </Switch>
        </div>
      </div>
      <div
        className={`${
          'lg:ml-20'
        } transition-all duration-200`}
      >
        <MainFooter />
      </div>
    </div>
  );
}

export default Accounting;
